var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component, Renderer2, ElementRef } from '@angular/core';
var TdDataTableTableComponent = (function () {
    function TdDataTableTableComponent(_elementRef, _renderer) {
        this._elementRef = _elementRef;
        this._renderer = _renderer;
        this._renderer.addClass(this._elementRef.nativeElement, 'td-data-table');
    }
    return TdDataTableTableComponent;
}());
TdDataTableTableComponent = __decorate([
    Component({
        /* tslint:disable-next-line */
        selector: 'table[td-data-table]',
        styles: [":host { width: 100%; border-spacing: 0; overflow: hidden; border-collapse: collapse; } "],
        template: "<thead> <tr td-data-table-row> <ng-content select=th[td-data-table-column]></ng-content> </tr> </thead> <ng-content></ng-content>",
    }),
    __metadata("design:paramtypes", [ElementRef, Renderer2])
], TdDataTableTableComponent);
export { TdDataTableTableComponent };
//# sourceMappingURL=data-table-table.component.js.map


//////////////////
// WEBPACK FOOTER
// /home/mysticerp/domains/mysticerp.ro/public_html/mystic/agatexfe/~/@covalent/core/data-table/data-table-table/data-table-table.component.js
// module id = ../../../../@covalent/core/data-table/data-table-table/data-table-table.component.js
// module chunks = 4